import { render } from "./SuperAdminAproveUser.vue?vue&type=template&id=418fc521"
import script from "./SuperAdminAproveUser.vue?vue&type=script&lang=js"
export * from "./SuperAdminAproveUser.vue?vue&type=script&lang=js"

import "./SuperAdminAproveUser.vue?vue&type=style&index=0&id=418fc521&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__